/**
 * Servicio centralizado para limpiar todo el caché de sesión
 *
 * Esta función debe llamarse:
 * - Al iniciar sesión (antes de guardar el nuevo token)
 * - Al cerrar sesión
 * - Cuando se cambia de cuenta
 *
 * Garantiza que no queden datos residuales de sesiones anteriores.
 */
import { useGuardianStore } from "@/store/guardianStore";
import { useCursoStore } from "@/store/cursoStore";
import { useTesoreroStore } from "@/store/tesoreroStore";
import { useUserStore } from "@/store/userStore";
/** Limpia estado de navegación/contexto cuando la sesión deja de ser válida. */
export const clearStaleAuthState = () => {
    localStorage.removeItem("lastRoute");
    const cursoStore = useCursoStore();
    cursoStore.clearCurso();
    localStorage.removeItem("selectedCursoData");
};
export const clearAllSessionCache = () => {
    console.log("🧹 Limpiando todo el caché de sesión...");
    // Limpiar tokens de autenticación (id + refresh)
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    // Limpiar datos del usuario
    const userStore = useUserStore();
    userStore.clearEmail();
    localStorage.removeItem("userEmail");
    localStorage.removeItem("email"); // También limpiar el email directo en localStorage
    localStorage.removeItem("userRole");
    // Limpiar datos del guardian (nombre, cursos, etc.)
    const guardianStore = useGuardianStore();
    localStorage.removeItem("guardian-store");
    guardianStore.fullName = "";
    guardianStore.courses = [];
    guardianStore.isIncomplete = false;
    // Limpiar datos del curso seleccionado
    clearStaleAuthState();
    // Limpiar datos del tesorero
    const tesoreroStore = useTesoreroStore();
    tesoreroStore.clearAll();
    // Limpiar caché de cursos (función global)
    if (typeof window !== "undefined" && typeof window.clearCoursesCache === "function") {
        window.clearCoursesCache();
    }
    // Limpiar caché de cursos en sessionStorage
    try {
        const keys = Object.keys(sessionStorage);
        keys.forEach((key) => {
            if (key.startsWith("cursos_")) {
                sessionStorage.removeItem(key);
            }
        });
    }
    catch (e) {
        console.warn("Error al limpiar sessionStorage de cursos:", e);
    }
    // Limpiar cachés de tesorería
    try {
        const keys = Object.keys(localStorage);
        keys.forEach((key) => {
            if (key.startsWith("tesoreria-")) {
                localStorage.removeItem(key);
            }
        });
    }
    catch (e) {
        console.warn("Error al limpiar cachés de tesorería:", e);
    }
    console.log("✅ Caché de sesión limpiado completamente");
};
